import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/content.css";

const ContentHubPage = () => {
  const navigate = useNavigate();

  return (
    <div className="admin-container">
      <h2>Content Management</h2>

      <div className="content-grid">

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/vocabulary")}
        >
          <h3>Vocabulary</h3>
          <p>Manage words, meanings, examples</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/vocabulary-groups")}
        >
          <h3>Vocabulary Groups</h3>
          <p>Manage vocabulary collections</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/grammar")}
        >
          <h3>Grammar</h3>
          <p>Manage grammar topics</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/tongue")}
        >
          <h3>Tongue Twisters</h3>
          <p>Manage speaking practice content</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/quick-boost")}
        >
          <h3>Quick Boost</h3>
          <p>Manage short video lessons</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/daily-sentences")}
        >
          <h3>Daily Sentences</h3>
          <p>Manage everyday English sentences</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/official-sentences")}
        >
          <h3>Official Sentences</h3>
          <p>Manage professional & formal sentences</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/similar-words")}
        >
          <h3>Similar Words</h3>
          <p>Manage confusing words & homophones</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/ipa-symbols")}
        >
          <h3>IPA Symbols</h3>
          <p>Manage IPA phonetic symbols</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/ipa-lessons")}
        >
          <h3>IPA Lessons</h3>
          <p>Manage IPA pronunciation lessons</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/phrases")}
        >
          <h3>Phrases & Abbreviations</h3>
          <p>Manage phrases, idioms, abbreviations & phrasal verbs</p>
        </div>

        <div
          className="content-card"
          onClick={() => navigate("/admin/content/homonyms")}
        >
          <h3>Homonyms</h3>
          <p>Manage words with multiple meanings</p>
        </div>

      </div>
    </div>
  );
};

export default ContentHubPage;